/**
 * Labstep
 *
 * @module components/Layout/LoadingEntityCreate
 * @desc Displays loading animation on entity creation
 */

import { FullScreenPage as LayoutFullScreenPage } from 'labstep-web/components/Layout/FullScreenPage';
import { LoaderLogo } from 'labstep-web/core/Loader/Logo';
import { objectOrFunction } from 'labstep-web/services/react.service';
import type React from 'react';
import { getError, getStatus } from '../LoadingContent/utils';
import styles from './styles.module.scss';
import type { LayoutLoadingEntityCreateProps } from './types';

export const LayoutLoadingEntityCreate: React.FC<
  LayoutLoadingEntityCreateProps
> = (props) => {
  const { defaultFetching, status, children, message } = props;

  const { isFetching, error } = getStatus(status, defaultFetching);

  if (isFetching) {
    return (
      <LayoutFullScreenPage>
        <div className={styles.fullPageLoader}>
          <LoaderLogo />
          <div className={styles.message}>{message}</div>
        </div>
      </LayoutFullScreenPage>
    );
  }

  if (error) {
    return (
      <LayoutFullScreenPage>
        <div className={styles.errorContent}>
          {getError(error, true)}
        </div>
      </LayoutFullScreenPage>
    );
  }

  return <>{objectOrFunction(children)}</>;
};
